module.exports = __webpack_public_path__ + "img/wx-code1.72dd072c.png";